export enum BatchWorkflowStatus {
   INITIALIZING = 'initializing',
   OPERATING = 'operating',
   FINALIZING = 'finalizing',
   COMPLETE = 'complete',
}
